module.exports = __webpack_public_path__ + "static/media/forgot-pass.0ad48f52.png";